import { render, staticRenderFns } from "./ProductSpecifications.vue?vue&type=template&id=6f4693f8&scoped=true&"
import script from "./ProductSpecifications.vue?vue&type=script&lang=js&"
export * from "./ProductSpecifications.vue?vue&type=script&lang=js&"
import style0 from "./ProductSpecifications.vue?vue&type=style&index=0&id=6f4693f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4693f8",
  null
  
)

export default component.exports